import moment from 'moment'
import momentParseFormat from 'moment-parseformat'

import { DEFAULT_DATE_DISPLAY_FORMAT, dateDisplayFormat } from '@/utilities'

export default {
  data () {
    return {
      parsedDate: '',
    }
  },
  computed: {
    uncertainDate () {
      return !this.date && this.boxChecked
    },
  },
  methods: {
    addComboValidation () {
      const vm = this

      if (this.required) {
        this.rules.date = [
          v => {
            let isValid = true
            let errorMessage = ''
            if (!v && !vm.boxChecked) {
              isValid = false
              errorMessage = 'Date is required or check box if Unknown date'
            } else if (!vm.dateValidFromInput) {
              isValid = false
              errorMessage = 'Date is invalid'
            }
            this.$emit('valid-changed', isValid, errorMessage)
            return isValid || errorMessage
          },
        ]
        // issue: date field is length > 0 but also invalid

        this.rules.uncertain = [
          v => {
            let isValid = true
            if (!v && (!vm.dateValidFromInput || this.dateFormatted.length === 0)) isValid = false
            else isValid = true

            const errorMessage = 'Date is required or check box if Unknown date'
            this.$emit('valid-changed', isValid, errorMessage)
            return isValid || errorMessage
          },
        ]

      // default validation
      } else this.rules.date = [this.dateFieldValid()]
    },
    addBasicValidation () {
      const vm = this
      if (this.required) {
        let isValid = true
        let errorMessage = ''
        this.rules.date = [
          v => {
            if (!v) {
              isValid = false
              errorMessage = 'Required'
            } else if (!vm.dateValidFromInput) {
              isValid = false
              errorMessage = 'Invalid'
            } else isValid = true

            this.$emit('valid-changed', isValid, errorMessage)

            return isValid || errorMessage
          },
        ]
      } else this.rules.date = [this.dateFieldValid()]
    },
    dateFieldValid () {
      const errorMessage = 'Date is invalid'

      this.$emit('valid-changed', this.dateValidFromInput, errorMessage)

      return this.dateValidFromInput || errorMessage
    },
    parseManuallyEnteredDate () {
      let validParsing = false
      // only try to parse user entries of 5 digits or above,
      // otherwise mark as invalid
      if (this.dateFormatted.length > 4) validParsing = this.parseDate(this.dateFormatted, 'YYYY-MM-DD')
      else if (this.dateFormatted.length === 0) {
        // a blank date is 'valid' unless required,
        // (calculated in lines 22-24)
        this.resetValidation(true)
        return
      }

      if (validParsing) {
        this.dateInput = this.parsedDate
        this.resetValidation(true)
      } else this.resetValidation(false)
    },
    focusOpen () {
      const vm = this
      // need this as v-menu field
      // update is called right after this
      // which sets menuOpen to false
      setTimeout(function () {
        vm.menuOpen = true
      }, 300)
    },
    formatDate (date) {
      if (!date) return ''

      return dateDisplayFormat(date)
    },
    stringIsDateWithoutSlash (dateString) {
      let stringIsDate = false
      // if string is not all digits & length 8
      if (!/\d{8}$/.test(dateString.trim())) return stringIsDate

      const month = parseInt(dateString.slice(0, 2))
      const day = parseInt(dateString.slice(2, 4))
      const year = parseInt(dateString.slice(-4))
      if ((month > 0 && month <= 12) &&
        (day > 0 && day <= 31) &&
        (year > 1900 && year <= 2100)) stringIsDate = true

      return stringIsDate
    },
    parseDate (dateToFormat, customFormat) {
      let validParsing = true
      let tempParsedDate = dateToFormat
      let detectedFormat = ''
      if (this.stringIsDateWithoutSlash(tempParsedDate)) detectedFormat = 'MMDDYYYY'
      else detectedFormat = momentParseFormat(tempParsedDate, { preferredOrder: 'MDY' })

      try {
        // Convert unwanted formats
        if (detectedFormat !== DEFAULT_DATE_DISPLAY_FORMAT) tempParsedDate = moment(tempParsedDate, detectedFormat)
        else tempParsedDate = moment(tempParsedDate, DEFAULT_DATE_DISPLAY_FORMAT)
      } catch (error) {
        validParsing = false
      }

      if (!tempParsedDate.isValid()) validParsing = false
      else {
        this.dateValidFromInput = true
        this.parsedDate = tempParsedDate.format(customFormat)
      }

      return validParsing
    },
    resetValidation (validValue) {
      this.dateValidFromInput = validValue
      this.$refs.form.validate()
    },
  },
  watch: {
    dateFormatted (val) {
      // catch cases where the date is empited
      if (!val || val.length === 0) this.$emit('update-date', val)
    },
    date (newVal) {
      // handling case where date prop
      // is updated by code
      const newDateFormatted = this.formatDate(newVal)
      if (newDateFormatted !== this.dateFormatted) this.dateFormatted = newDateFormatted

      this.$nextTick(_ => {
        this.$refs.form.validate()
      })
    },
    uncertain () {
      this.$nextTick(_ => {
        this.$refs.form.validate()
      })
    },
  },
}
